// extracted by mini-css-extract-plugin
export default {"not-found":"NotFound_not-found__eA3h8","not-found__header":"NotFound_not-found__header__2NBEG"};